import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import Switch from 'react-switch';
import {deleteFavourite, saveProfileWatch, deleteProfileWatch} from '../../actions';
import styles from './FavouriteControls.scss';
import TrackReasonsModal from '../Modal/TrackReasonsModal/TrackReasonsModal';
import UntrackModal from '../Modal/UntrackModal/UntrackModal';

class FavouriteControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTrackModal: false,
      showUntrackModal: false
    };
  }

   toggleTrackPropertyModal = () => {
     this.setState({showTrackModal: !this.state.showTrackModal});
   };

  toggleUntrackPropertyModal = () => {
    this.setState({showUntrackModal: !this.state.showUntrackModal});
  };

  trackProperty = (trackReason) => {
    this.props.saveProfileWatch({propertyId: this.props.property.propertyId,
      property: this.props.property,
      subscribedPropertyReason: trackReason,
    });
    this.toggleTrackPropertyModal();
  }

  untrackProperty = () => {
    this.props.deleteProfileWatch({propertyId: this.props.property.propertyId});
    this.toggleUntrackPropertyModal();
  };
  
  handleFavouriteChange = (newValue) => {
    newValue ? this.toggleTrackPropertyModal() : this.toggleUntrackPropertyModal();
  }
  render() {
    return (
      <div className="w-100 d-flex justify-content-between align-items-center">
        <div>
          <label className={'d-flex flex-row align-items-center m-0 ' + styles.switchLabel + (this.props.disablePW ? ' ' + styles.disabled : '')}>
            <Switch
              onChange={this.handleFavouriteChange}
              checked={this.props.isPropertyTracked}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3399FF"
              offColor="#bebebe"
              width={20}
              height={12}
              disabled={this.props.disablePW}
            />
            <span className="smText pl-1">{this.props.isPropertyTracked ? 'Tracking Property' : 'Track this property'}</span>
          </label>
        </div>
        <div className={styles.deleteIcon} onClick={() => this.props.deleteFavourite({propertyId: this.props.property.propertyId})} title="Remove favourite"></div>
        <TrackReasonsModal
          isPropertyTrackModal={true}
          showModal={this.state.showTrackModal}
          handleShowModalChange={() => this.toggleTrackPropertyModal()}
          handleTrackSubmit={(trackReason) => this.trackProperty(trackReason)} />
        <UntrackModal isPropertyUntrackModal={true}
          showModal={this.state.showUntrackModal}
          handleCloseModalChange={() => this.toggleUntrackPropertyModal()}
          handleUntrackButtonClick={() => this.untrackProperty()}
        />
      </div>
    );
  }
}

FavouriteControls.propTypes = {
  property: PropTypes.object.isRequired,
  disablePW: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    profileWatch: state.profileWatch,
    userFavourites: state.userFavourites,
  };
};
const mapDispatchToProps = {
  deleteFavourite, saveProfileWatch, deleteProfileWatch,
};
export default connect(mapStateToProps, mapDispatchToProps)(FavouriteControls);

